import React from 'react';
import { IconBase } from '../Base';
export const IconPLN = (props) => (React.createElement(IconBase, { ...props, viewportSize: 24 },
    React.createElement("g", { clipPath: "url(#clip0_2_8779)" },
        React.createElement("path", { d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z", fill: "#F0F0F0" }),
        React.createElement("path", { d: "M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12", fill: "#D80027" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "clip0_2_8779" },
            React.createElement("rect", { width: "24", height: "24", fill: "white" })))));
//# sourceMappingURL=PLN.js.map